import { PageHero } from '@/components/page-hero'
import { T } from '@/components/t'

export const FaqHeader = () => {
    return (
        <PageHero
            title={<T span t={'faq.hero.title'} />}
            description={<T span t={'faq.hero.description'} />}
        />
    )
}
